const TR = {
  "english-key": "EN",
  "turkish-key": "TR",

  //   Buttons
  "close-btn": "Kapalı",
  "ok-btn": "Tamam",
  "next-btn": "Sonraki",
  "back-btn": "Geri",
  "show-recommendations-btn": "Önerileri göster",

  //   Main
  "first-line-main": "İçeceğinizi kendiniz yapmak ister misiniz?",
  "second-line-main": "Hadi!!",
  "third-line-main": "İçeceğinizi istediğiniz gibi yapalım",
  "get-started-main": "Başlamak",
  "make-your-cocktail-header": "Kokteylinizi Yapın",
  "recommendations-header": "öneriler",

  //   Making Modal
  "personal-step-label": "Kişisel",
  "details-step-label": "Detaylar",
  "review-step-label": "Gözden geçirmek",
  "name-of-cocktail-bar": "Kokteyl barının adı:",
  "first-name-of-owner": "First name of owner:",
  "last-name-of-owner": "sahibinin soyadı:",
  "phone-number": "Telefon numarası:",
  "email-address": "E-posta adresi:",
  category: "Kategori:",
  "type-of-drink": "içecek türü:",
  "type-of-glass": "cam türü:",
  ingredients: "İçindekiler:",
  "choose-category": "Kategori Seçin",
  "choose-type": "türü seç",
  "choose-ingredients": "malzemeleri seç",
  "ingredients-not-selected": "**Malzemeler seçilmedi",
  "please-enter-name": "Lütfen adı girin",
  "please-enter-first-name": "Lütfen ilk adı girin",
  "please-enter-last-name": "Lütfen soyadınızı giriniz",
  "please-enter-number": "Lütfen numarayı girin",
  "please-enter-email": "Lütfen e-postayı girin",
  "please-select-cat": "Lütfen kategori seçiniz",
  "please-select-type": "Lütfen türü seçin",
  "please-select-ingredients": "Lütfen Malzemeleri Seçin",

  //   Recommendations
  "cock-name": "Kokteyl Adı: ",
  "cock-tags": "Etiketler: ",
  "no-similar-cocktails": "Benzer kokteyl yok",
};

export default TR;
